import { __awaiter, __decorate } from "tslib";
import { theme } from '@dojo/framework/core/mixins/Themed';
import { w, v } from '@dojo/framework/core/vdom';
import { storeInject } from '@dojo/framework/stores/StoreInjector';
import { I18nThemed } from 'interfaces/mixins';
import { lccstore } from 'lcc-state';
import { get_related } from 'cache-store';
import { svc } from '../support/svc';
import { RelatedTopic } from './related-topic';
import css from '../css/related-topics.m.css';
let RelatedTopics = class RelatedTopics extends I18nThemed {
    get_related() {
        return __awaiter(this, void 0, void 0, function* () {
            const { topicid } = this.properties;
            const language = window.hcstatic.portal_language || 'en';
            const { get, path } = lccstore;
            const version = get(path('bookversion'));
            this.related = yield get_related({
                key: topicid,
                version,
                language,
                related_getter: ({ key, version, language }) => svc.related_topics({ topicid: key, version, language })
            });
            this.invalidate();
        });
    }
    render_related() {
        if (this.related === undefined) {
            return [];
        }
        const { bundle } = this.properties;
        const localizedBundle = this.localizeBundle(bundle);
        const { messages: { related_topics = '[ditabook] related_topics' } } = localizedBundle;
        const relatedItems = this.related.map((topicid) => w(RelatedTopic, { topicid, localizedBundle }));
        return [
            v('h4', { classes: [this.theme(css.heading)] }, [related_topics]),
            v('div', { classes: [this.theme(css.relatedItems)] }, relatedItems)
        ];
    }
    render() {
        if (this.related === undefined) {
            this.get_related();
            return null;
        }
        const len_related = this.related.length;
        return v('div', { key: 'related-topics', xqa: 'topics related', classes: [this.theme(css.root)] }, len_related > 0 ? this.render_related() : []);
    }
};
RelatedTopics = __decorate([
    theme(css),
    storeInject({
        name: 'lcc-state',
        getProperties: (store) => {
            const { get, path } = store;
            const dynls = get(path('dynls'));
            const bundle = dynls.get('ditabook');
            return {
                bundle
            };
        },
        paths: [['dynls']]
    })
], RelatedTopics);
export { RelatedTopics };
